import React from 'react';

const WorkshopStepCard = ({ title, subtitle, items }) => (
  <div className="workshop-step-card">
    <h3 className="subtitle" style={{ textTransform: 'uppercase', letterSpacing: '0.05rem', marginBottom: '0.5rem' }}>
      {title}
    </h3>
    <h2 className="title" style={{ textAlign: 'center', marginBottom: '1rem' }}>
      {subtitle}
    </h2>
    <ul className="workshop-step-list">
      {items.map((item, idx) => (
        <li key={idx}>{item}</li>
      ))}
    </ul>
  </div>
);

export default WorkshopStepCard;
